import { createContext, useContext } from 'react';

const GetDataOverrideContext = createContext(undefined);
export const GetDataOverrideContextProvider = GetDataOverrideContext.Provider;
export const useGetDataOverrideContextValue = () => useContext(GetDataOverrideContext);
